import { TOptionsQuery } from 'types/common';
import { TControlInitDetail } from 'types/controlInit';
import actionCreatorFactory from 'typescript-fsa';

const ac = actionCreatorFactory();

export default {
  getControlInit: ac<TOptionsQuery<TControlInitDetail>>('getControlInit'),
  getControlInitDetail: ac<{ ctrRsId: number; groupId: number }>('getControlInitDetail'),
  createControlInit: ac<{ name?: string; fname?: string; groupId: number }>('createControlInit'),
  updateControlInit: ac<{ ctrRsId: number; name?: string; fname?: string; groupId: number }>('updateControlInit'),
  deleteControlInit: ac<{ ctrRsId: number; groupId: number }>('deleteControlInit'),
  uploadControlInitFile: ac<FormData>('uploadControlInitFile'),
  downloadControlInitFile: ac<{ ctrRsId: number; groupId: number }>('downloadControlInitFile'),
};
